import { isNil } from 'lodash';

/**
 * Fetch the GeoJSON stored in the URL.
 *
 * @async
 * @param {string} url - The URL where the GeoJSON is stored.
 * @returns {Promise<object>} The geojson file stored in the URL.
 * @throws {Error} If something goes wrong.
 */
const loadGeoJSONFromURL = async url => {
  try {
    const response = await fetch(url, {
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    if (response.ok) {
      const geojson = await response.json();
      if (isNil(geojson)) throw new Error('Empty Response');
      return geojson;
    }
    console.error(response);
    throw new Error('Network response was not ok. Server Error');
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadGeoJSONFromURL;
